var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.5C11.2144 5.5 9.95772 5.88122 8.8888 6.59545C7.81988 7.30968 6.98676 8.32484 6.49479 9.51256C6.00282 10.7003 5.87409 12.0072 6.1249 13.2681C6.3757 14.529 6.99477 15.6872 7.90381 16.5962C8.81285 17.5052 9.97104 18.1243 11.2319 18.3751C12.4928 18.6259 13.7997 18.4972 14.9874 18.0052C16.1752 17.5132 17.1903 16.6801 17.9046 15.6112C18.6188 14.5423 19 13.2856 19 12C18.9982 10.2767 18.3128 8.62441 17.0942 7.40582C15.8756 6.18722 14.2234 5.50182 12.5 5.5ZM16 12.5H12.5C12.3674 12.5 12.2402 12.4473 12.1464 12.3536C12.0527 12.2598 12 12.1326 12 12V8.5C12 8.36739 12.0527 8.24021 12.1464 8.14645C12.2402 8.05268 12.3674 8 12.5 8C12.6326 8 12.7598 8.05268 12.8536 8.14645C12.9473 8.24021 13 8.36739 13 8.5V11.5H16C16.1326 11.5 16.2598 11.5527 16.3536 11.6464C16.4473 11.7402 16.5 11.8674 16.5 12C16.5 12.1326 16.4473 12.2598 16.3536 12.3536C16.2598 12.4473 16.1326 12.5 16 12.5Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.0fd9cd936e7e9c35e3a0ad9d418ed631.svg";
export { ForwardRef as ReactComponent };